import { useNavigate, useParams } from 'react-router-dom'
import { GUIA_LABELS } from '@utils/guiaLabels.js'
import { getGuiaTopicoForCalc, getPassoForCalc } from '@content/calc-passos.js'
import { ROUTES, topicoDetailPath } from '@utils/constants.js'
import { EmptyPanel } from '@components/primitives/EmptyPanel.js'
import { Button } from '@components/primitives/Button.js'
import { PageShell } from '@components/layout/PageShell.js'
import { FerramentaRouter } from '@components/ferramentas/FerramentaRouter.js'

const CALC_TITLES: Record<string, string> = {
  topografia: 'Diagnóstico de Topografia',
  'corte-aterro': 'Corte e Aterro',
  insolacao: 'Análise de Insolação',
  sondagem: 'Custo de Sondagem SPT',
  sistemas: 'Comparador de Sistemas',
  espessura: 'Espessura de Parede',
  vaos: 'Vãos Livres',
  casca: 'Fator Casca',
  comodo: 'Custo por Cômodo',
  otimizador: 'Otimizador de Áreas',
  aberturas: 'Aberturas/Esquadrias',
  'pe-direito': 'Pé-direito',
  viabilidade: 'Simulador de Viabilidade',
  'curva-s': 'Curva S de Desembolso',
  reserva: 'Reserva de Contingência',
  financiamento: 'Financiamento',
  inflacao: 'Inflação vs Cronograma',
  contratacao: 'Tipos de Contratação',
  equipe: 'Equipe Ideal',
  pedreiro: 'Custo do Pedreiro',
  aditivos: 'Detector de Aditivos',
  impostos: 'Impostos Totais',
  inss: 'INSS de Obra',
  cno: 'Alerta de CNO',
  habitese: 'Habite-se',
  cronograma: 'Cronograma Físico-Financeiro',
  'anti-retrabalho': 'Identificador anti-retrabalho',
  atrasos: 'Detector de Atrasos',
  'manta-telhado': 'Manta vs Telhado',
}

/** Ferramenta aberta pelo índice — pode voltar à etapa correspondente no guia. */
export function CalculadoraDetailPage() {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const passo = id ? getPassoForCalc(id) : null
  const titulo = (id && CALC_TITLES[id]) || GUIA_LABELS.ferramentaFallback
  const guiaTopicoId = id ? getGuiaTopicoForCalc(id) : null

  if (!id || !passo) {
    return (
      <PageShell>
        <EmptyPanel
          title={GUIA_LABELS.ferramentaNaoEncontrada}
          description='Esta ferramenta não está disponível no catálogo.'
          actionLabel={GUIA_LABELS.verFerramentas}
          onAction={() => navigate(ROUTES.CALCULADORAS)}
        />
      </PageShell>
    )
  }

  return (
    <PageShell>
      <div className='cf3-block'>
        <p className='cf3-overline'>{GUIA_LABELS.ferramentaOverline}</p>
        <h2 className='cf3-subsection-title'>{titulo}</h2>
        {passo && guiaTopicoId && (
          <Button
            variant='secondary'
            size='sm'
            className='cf3-ferramenta-voltar-passo cf-btn--inline'
            onClick={() => navigate(topicoDetailPath(passo.moduloId, guiaTopicoId))}
          >
            {GUIA_LABELS.verNaEtapaGuia}
          </Button>
        )}
      </div>
      <section className='cf3-block cf3-ferramenta-isolada'>
        <FerramentaRouter topicoId={id} persistKey={id} />
      </section>
    </PageShell>
  )
}
